import { PageRenderer } from "@/components/sections/PageRenderer";
import { LocationsDirections } from "@/components/common/LocationsDirections";
import { SectionTitle } from "@/components/common/SectionTitle";
import { LocationBlock } from "@/components/cards/LocationBlock";
import { LocationDetail } from "@/components/cards/LocationDetail";
import { Loader, EmptyState } from "@/components/common/Loader";
import { usePublicContent } from "@/lib/useContent";

export default function Locations() { return <PageRenderer pageKey="locations" />; }

export const LocationsBody = () => {
  const { data, loading } = usePublicContent("locations");

  return (
    <div data-testid="locations-page">
      {/* hero via PageRenderer */}

      {/* Top: quick-glance location cards */}
      <section id="locations-choose" className="scroll-mt-24 bg-background py-16 sm:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
          <SectionTitle
            eyebrow="Two Facilities"
            title="Choose Your Gym"
            subtitle="Get directions, book a session, view packages, or reach out — all in one tap."
          />
          <div className="mt-10">
            {loading ? (
              <Loader />
            ) : data.length === 0 ? (
              <EmptyState title="No locations yet" />
            ) : (
              <div className="grid gap-8 md:grid-cols-2">
                {data.map((l) => <LocationBlock key={l.id} item={l} />)}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Detailed sections per location */}
      {!loading && data.length > 0 && (
        <section id="locations-details" className="scroll-mt-24 border-t border-border bg-card/30 py-16 sm:py-20">
          <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
            <SectionTitle
              eyebrow="Plan Your Visit"
              title="Location Details"
              subtitle="Hours, services, amenities, and parking for each facility."
            />
            <div className="mt-10 grid gap-10">
              {data.map((l, i) => <LocationDetail key={l.id} item={l} index={i} />)}
            </div>
          </div>
        </section>
      )}

      <div id="locations-directions" className="scroll-mt-24">
        <LocationsDirections />
      </div>
    </div>
  );
}
